import axios from "axios";
import { errorMessage, tokenExpired } from "@/api/errorMessages";
import * as api from "@/api/oauth";

export default {
  namespaced: true,
  state: {
    unassignAux: 0,
    distributeQuotes: 0,
    statistics: 0,
    statisticsDate: 0,
    numberOfQuotes: 0
  },
  getters: {},
  mutations: {
    unassign(state) {
      state.unassignAux += 1;
    },
    distributeQuotes(state) {
      state.distributeQuotes += 1;
    },
    setStatistics(state) {
      state.statistics += 1;
    },
    setStatisticsByDate(state) {
      state.statisticsDate += 1;
    },
    setNumberOfQuotes(state) {
      state.numberOfQuotes += 1;
    }
  },
  actions: {
    async distributeQuotes({ commit }, info) {
      let response;
      try {
        if (info.numberOfQuotes === "" || info.numberOfQuotes === null) {
          response = await axios.post(
            process.env.VUE_APP_BACK_ROUTE +
              `/api/allocate/admin/distribute-quotes/${info.departmentId}/`,
            null,
            api.getToken()
          );
        } else {
          response = await axios.post(
            process.env.VUE_APP_BACK_ROUTE +
              `/api/allocate/admin/distribute-quotes/${info.departmentId}/?quotes_per_user=${info.numberOfQuotes}`,
            null,
            api.getToken()
          );
        }
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
      if (response.status == 200) {
        commit("distributeQuotes");
      }
      return response;
    },

    async assignById({ commit }, id) {
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE + `/api/allocate/user/by-id/`,
          id,
          api.getToken()
        );
        if (response.status == 200) {
          commit("setNumberOfQuotes", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async unassignQuotes({ commit }, info) {
      try {
        let response = await axios.put(
          process.env.VUE_APP_BACK_ROUTE + "/api/allocate/user/deallocate/",
          info,
          api.getToken()
        );
        commit("unassign");
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async clearQuotes({ commit }, departmentId) {
      try {
        let response = await axios.put(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/allocate/admin/deallocate_all_by_department/${departmentId}/`,
          null,
          api.getToken()
        );
        if (response.status == 200) {
          commit("setNumberOfQuotes", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async getStatistics({ commit }, departmentId) {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/user/${departmentId}/statistics/`,
          api.getToken()
        );
        if (response.status === 200) {
          commit("setStatistics", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 204) {
          errorMessage();
        }
        return err.response;
      }
    },

    async getStatisticsByDate({ commit }, info) {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/user/${info.id}/statistics/?init_date=${info.firstDate}&finish_date=${info.secondDate}${info.responseType}&include_requote=${info.includeRequote}`,
          api.getToken()
        );
        if (response.status === 200) {
          commit("setStatistics", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 204) {
          errorMessage();
        }
        return err.response;
      }
    }
  }
};
